/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Mtmsa_DescriptionInputs */



/**
* | output |
* | --- |
* | "Support against the Marine Terminal Management and Self-Assessment programme." |
*
* @param {Service_Mtmsa_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_mtmsa_description = /** @type {((inputs?: Service_Mtmsa_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Mtmsa_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("对照海运码头管理与自评估项目提供支持。")
	return /** @type {LocalizedString} */ ("Support against the Marine Terminal Management and Self-Assessment programme.")
});